// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/routes/company/routes/Jobs/components/Wrapper/Wrapper.scss
// module id = 759
// module chunks = 0